// 设置技术人员select
const SETDEVOPSSELECT = 'setDevopsSelect';
// 筛选
const FILTERSELECT = 'filterSelect'
// 设置进度条
const SETPROGRESSBAR = 'setProgressBar';
// 设置用户权限
const USERAUTHORITY = 'userauthority'
// 启动webSocket
const OPENWEBSOCKET = 'openWebSocket'
// 设置webSocket
const SENDWEBSOCKET = 'sendWebSocket'
// 停止webSocket
const CLOSEWEBSOCKET = 'closeWebSocket'
// 储存webSocket 信息
const SAVEWEBSOCKET = 'saveWebSocket'
// 自动滚到底部
const SCROLLTOBOTTOM = 'scrollToBottom'
// 文件导出
const FILEEXPORT = 'fileExport'
// 设置项目体系
const SETDEVOPSSYSTEM = 'setDevopsSystem';
const SETDEVOPSUSERLIST = 'setDevopsUserList';

const SETDEVOPSSTATUSLIST = 'setDevopsStatusList';


const SETDEVOPSMENULIST = 'setDevopsMenuList';

const SETDEVOPSWORKORDERCONFIGLIST = 'setDevopsWorkOrderConfigList';




export {
    SETDEVOPSSELECT,
    SETPROGRESSBAR,
    USERAUTHORITY,
    OPENWEBSOCKET,
    CLOSEWEBSOCKET,
    SENDWEBSOCKET,
    SAVEWEBSOCKET,
    SCROLLTOBOTTOM,
    FILTERSELECT,
    FILEEXPORT,
    SETDEVOPSSYSTEM,
    SETDEVOPSUSERLIST,
    SETDEVOPSSTATUSLIST,
    SETDEVOPSMENULIST,
    SETDEVOPSWORKORDERCONFIGLIST,
}
